import { transformGraphqlProduct } from './product.js';

export default {
  name: 'transformGraphqlProducts',
  magic: (el, { Alpine }) => {
    return (graphqlProducts) => {
      if (!Array.isArray(graphqlProducts)) return [];
      return graphqlProducts.map(product => transformGraphqlProduct(product));
    };
  }
}